import { ReactNode } from 'react';
import HomeV2Background from './HomeV2Background.js';
import HomeV2Header, { HomeV2HeaderPlaceholder } from './HomeV2Header.js';
import HomeV2Footer, { HomeV2FooterPlaceholder } from './HomeV2Footer.js';
import type { TimeOfDayConfig } from './timeOfDayConfig.js';

interface HomePageLayoutProps {
  children?: ReactNode;
  timeOfDayConfig?: TimeOfDayConfig;
  isTransitioning?: boolean;
  showAvatar?: boolean;
  showCloudLogo?: boolean;
  onCloudClick?: () => void;
}

export default function HomePageLayout({
  children,
  timeOfDayConfig,
  isTransitioning = false,
  showAvatar = true,
  showCloudLogo = false,
  onCloudClick,
}: HomePageLayoutProps) {
  return (
    <div className="min-h-screen relative" style={{ overflow: 'hidden' }}>
      <HomeV2Header
        showCloudLogo={showCloudLogo}
        backgroundColor={timeOfDayConfig?.headerBackground}
        isTransitioning={isTransitioning}
        showAvatar={showAvatar}
        onCloudClick={onCloudClick}
      />
      <HomeV2HeaderPlaceholder />

      <HomeV2Background
        timeOfDayConfig={timeOfDayConfig}
        showNightDecorations={timeOfDayConfig?.showNightDecorations}
        showMorningGlow={timeOfDayConfig?.showMorningGlow}
        isTransitioning={isTransitioning}
        gradientFunction="default"
      >
        <main
          className="overflow-x-hidden flex flex-col"
          style={{ minHeight: '100vh' }}
        >
          <div className="max-w-md lg:max-w-xl mx-auto px-4 w-full flex-1 flex flex-col">
            {children}
          </div>
          <HomeV2FooterPlaceholder />
        </main>
      </HomeV2Background>

      <HomeV2Footer activeTab="daily-sparks" isTransitioning={isTransitioning} />
    </div>
  );
}
